import { goDateString } from "./common";

export const SHIFT_SYNC_BUTTON = "smarthr-shift-sync-button";
const MAIN_SELECTION_BUTTON = "smarthr-selection-button"

export function syncShifts(activeUserID, activeBranchID, startDate, endDate) {
  $(`#${MAIN_SELECTION_BUTTON}`).addClass('loading');
  const data = JSON.stringify({
    "startDate": goDateString(startDate),
    "endDate": goDateString(endDate),
  });
    fetch(`/dashboard/${activeUserID}/smarthr/shift_sync?c=${activeBranchID}`,{method: "POST", body: data}).then(response => {
    $(`#${MAIN_SELECTION_BUTTON}`).removeClass('loading');
    if (!response.ok) {
        response.text().then(errorMsg => {
            alertModal.alert(`同期に失敗しました: ${errorMsg}`, true)
        })
    } else {
        let msg = "インポートの処理中です。多数のシフトをインポートする場合、更新完了まで時間がかかることがあります。"
        alertModal.alertSuccess(msg, true)
    }
  })
}